class Checkbox {
    constructor(wrapper) {
        this.wrapper = wrapper
        this.input = wrapper.querySelector('.checkbox-input')
        this.box = wrapper.querySelector('.checkbox-box')
        this.checked = false

        this.bindEventListeners()
    }

    bindEventListeners() {
        this.input.addEventListener('change', (e) => this.handleChange(e))
    }

    handleChange(e) {
        this.checked = e.currentTarget.checked
        this.update()
    }

    update() {
        if (this.checked) this.box.classList.add('active')
        else this.box.classList.remove('active')
    }
}

export default Checkbox
